// safeName
//
// safe string function for url slugs, data attributes etc.

const safeName = (data) => {

  if(typeof data === 'string') {
    return(data.replace(/\W+/g, '-').toLowerCase())
  }
  else {
    return ('')
  }

}

export { safeName }

